import {
  type DashRouteType,
  URL_PARTNER_SCOPED,
  URL_RETAILER_SCOPED,
  URL_SITE_SCOPED,
} from '@retailer-platform/dashboard/route-patterns'

const URL_LOYALTY = `${URL_RETAILER_SCOPED}${URL_SITE_SCOPED}/loyalty`
const URL_LOYALTY_PARTNER_SCOPED = `${URL_PARTNER_SCOPED}/loyalty`

const URL_LOYALTY_LIST = `${URL_LOYALTY_PARTNER_SCOPED}/programs`
// Per-L1 sibling URLs of URL_LOYALTY_LIST — same page, tier-restricted via
// `extraStoreConfigFilter`. The `/mp`, `/sf`, `/sfp` discriminators sit right
// after `${URL_LOYALTY_PARTNER_SCOPED}` so the parent
// `<DomainRoute route="loyalty-partner-scoped">` prefix still matches.
const URL_LOYALTY_LIST_MARKETPLACE = `${URL_LOYALTY_PARTNER_SCOPED}/mp/programs`
const URL_LOYALTY_LIST_STOREFRONT = `${URL_LOYALTY_PARTNER_SCOPED}/sf/programs`
const URL_LOYALTY_LIST_STOREFRONT_PRO = `${URL_LOYALTY_PARTNER_SCOPED}/sfp/programs`
const URL_LOYALTY_CREATE = `${URL_LOYALTY_PARTNER_SCOPED}/create`
// Per-L1 sibling URLs of URL_LOYALTY_CREATE — same page, tier-restricted via
// `extraStoreConfigFilter` so the create-page site picker only exposes
// store configs matching the L1 the user entered through.
const URL_LOYALTY_CREATE_MARKETPLACE = `${URL_LOYALTY_PARTNER_SCOPED}/mp/create`
const URL_LOYALTY_CREATE_STOREFRONT = `${URL_LOYALTY_PARTNER_SCOPED}/sf/create`
const URL_LOYALTY_CREATE_STOREFRONT_PRO = `${URL_LOYALTY_PARTNER_SCOPED}/sfp/create`

const URL_LOYALTY_HUB_PAGES = `${URL_LOYALTY}/hub-pages`
const URL_LOYALTY_HUB_PAGE_EDIT = `${URL_LOYALTY_HUB_PAGES}/edit/:pageId`
const URL_LOYALTY_HUB_PAGE_CREATE = `${URL_LOYALTY_HUB_PAGES}/create`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<
  | 'loyalty'
  | 'loyalty-partner-scoped'
  | 'loyalty-list'
  | 'loyalty-list-marketplace'
  | 'loyalty-list-storefront'
  | 'loyalty-list-storefront-pro'
  | 'loyalty-create'
  | 'loyalty-create-marketplace'
  | 'loyalty-create-storefront'
  | 'loyalty-create-storefront-pro'
  | 'loyalty-hub-page-edit'
  | 'loyalty-hub-page-create'
>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  loyalty: URL_LOYALTY,
  'loyalty-partner-scoped': URL_LOYALTY_PARTNER_SCOPED,
  'loyalty-list': URL_LOYALTY_LIST,
  'loyalty-list-marketplace': URL_LOYALTY_LIST_MARKETPLACE,
  'loyalty-list-storefront': URL_LOYALTY_LIST_STOREFRONT,
  'loyalty-list-storefront-pro': URL_LOYALTY_LIST_STOREFRONT_PRO,
  'loyalty-create': URL_LOYALTY_CREATE,
  'loyalty-create-marketplace': URL_LOYALTY_CREATE_MARKETPLACE,
  'loyalty-create-storefront': URL_LOYALTY_CREATE_STOREFRONT,
  'loyalty-create-storefront-pro': URL_LOYALTY_CREATE_STOREFRONT_PRO,
  'loyalty-hub-page-edit': URL_LOYALTY_HUB_PAGE_EDIT,
  'loyalty-hub-page-create': URL_LOYALTY_HUB_PAGE_CREATE,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
